export default __webpack_public_path__ + "static/media/640_dummy2016-beauty01-de.2d419bbc.png";